"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @category validators
 * @module isNull
 */
var isNull = function (o) { return o === null; };
exports.default = isNull;
